if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"learnbeat": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"accessor": 1,
"admin": 1,
"admin-create-group": 1,
"annotate": 1,
"author-activities": 1,
"author-chapters": 1,
"author-groups": 1,
"author-sections": 1,
"author-task-groups": 1,
"author-task-groups-library": 1,
"drawingcanvas": 1,
"grading-activities": 1,
"group-focus": 1,
"groups-teacher-materials": 1,
"highlightjs-styles": 1,
"library-add": 1,
"library-home": 1,
"library-view": 1,
"license-renewal": 1,
"molsketcher": 1,
"planner-groups": 1,
"popup-startofyear": 1,
"portfolio-group": 1,
"portfolio-project": 1,
"portfolio-projects": 1,
"progress-activities": 1,
"progress-answers": 1,
"progress-groups": 1,
"progress-students": 1,
"results-groups": 1,
"reviewapp-info": 1,
"search-material": 1,
"settings-groups": 1,
"settings-invite-students": 1,
"settings-users": 1,
"signup-create-group": 1,
"signup-no-email": 1,
"signup-pick-course": 1,
"signup-pilot": 1,
"signup-register": 1,
"studentgrading-fullscreenoverlay": 1,
"users-feedback": 1,
"views_components_taskGroups_edit_Edit_js-views_pages_task_groups_author_addElement_AddElement-53d872": 1,
"views_components_taskGroups_sources_source1_edit_Edit_js-views_components_taskGroups_sources_-de72f5": 1,
"views_pages_groups_settings_editGroupModal_EditGroupModal_js-views_pages_groups_settings_stud-7532f7": 1,
"words": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload